import { render, staticRenderFns } from "./photoResubmissionOrderList.vue?vue&type=template&id=72968684&scoped=true&"
import script from "./photoResubmissionOrderList.vue?vue&type=script&lang=js&"
export * from "./photoResubmissionOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72968684",
  null
  
)

export default component.exports